/*
 * @Author: 侯鹏许 
 * @Date: 2019-05-31 15:51:13 
 * @Last Modified by: 侯鹏许
 * @Last Modified time: 2019-05-31 15:56:15
 */
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
export function isEmptyString(str) {
  return str == "";
}
export function isMobile(mobile) {
  return /^1+\d{10}$/.test(mobile);
}
export function isIdcard(idcard) {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(idcard);
}
/**
 * 
 * @param {*} eInputId 手机号文本框id
 * @param {*} eSmsCodeId 短信验证码文本框id
 * @param {*} eBtnId 获取验证码按钮id
 * @param {*} initialTxt 获取验证码按钮上的文字
 * @param {*} readSecondTemplate 读秒模板 % 会秒数
 * @param {*} readSecondDuration 读秒时长
 */
export function bindSendSmsCode(eInputId, eSmsCodeId, eBtnId, initialTxt, readSecondTemplate, readSecondDuration) {
  let input = document.getElementById(eInputId);
  let sSmsCode = document.getElementById(eSmsCodeId);
  let btn = document.getElementById(eBtnId);
  if (btn && input) {
    btn.innerText = initialTxt;
    let VerShowSec = readSecondDuration;
    let IsCanVer = true;

    let myClickEvent = function () {
      if (IsCanVer) {
        let phone = input.value;
        if (isEmptyString(phone)) {
          util.messageBox("请输入手机号！")
          return;
        } else if (!isMobile(phone)) {
          util.messageBox("手机号格式不正确!");
          return;
        } else {
          // 发送短信验证码，读秒
          IsCanVer = false;
          this.innerText = readSecondTemplate.replace("%", VerShowSec);
          VerShowSec--;
          let tmpInterval = setInterval(() => {
            if (IsCanVer == false) {
              if (VerShowSec == 0) {
                this.innerText = initialTxt;
                VerShowSec = readSecondDuration;
                IsCanVer = true;
                clearInterval(tmpInterval);
              } else {
                this.innerText = readSecondTemplate.replace("%", VerShowSec);
                VerShowSec--;
              }
            }
          }, 1000);
          comreq.hdkVercode(phone);
        }
      }
    }
    if ("ontouchend" in document) {
      btn.addEventListener("touchstart", myClickEvent)
    } else {
      btn.addEventListener("click", myClickEvent)
    }
    sSmsCode.addEventListener("change", function () {
      if (this.value.length >= 8) {
        this.value = this.value.substring(0, this.value.length / 2);
      }
    })
  } else {
    util.messageBox("未找到短信验证码发送按钮或短信验证码输入框")
  }
}